import { useCallback, useLayoutEffect, useRef } from 'react'

/**
 * Returns a function with a stable identity that always calls the latest
 * `fn`. Use it for handlers passed into memoized AG Grid renderers/columnDefs
 * so the grid isn't rebuilt every time the handler's closure changes.
 * Only call the result from event handlers/effects, not during render.
 */
export function useStableCallback<Args extends unknown[], R>(
  fn: (...args: Args) => R
): (...args: Args) => R {
  const fnRef = useRef(fn)
  useLayoutEffect(() => {
    fnRef.current = fn
  })
  return useCallback((...args: Args) => fnRef.current(...args), [])
}
